import React from "react";

const Speaker = () => {
  return (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.3733 0.102229C15.7567 0.28734 16 0.70112 16 1.15845V16.2578C16 16.7151 15.7567 17.1289 15.3733 17.314C14.99 17.4991 14.5467 17.4301 14.23 17.1289L12.6767 15.6516C11.2233 14.2687 9.38667 13.4629 7.46333 13.3649V16.8385C7.46333 17.481 6.98667 18 6.39667 18H5.33C4.74 18 4.26333 17.481 4.26333 16.8385V13.3541C1.91 13.3541 0 11.2743 0 8.70811C0 6.14195 1.91 4.06217 4.26667 4.06217H7.08333C9.14333 4.05491 11.13 3.23824 12.68 1.76461L14.2333 0.28734C14.5467 -0.01392 14.9967 -0.0828832 15.3767 0.102229H15.3733ZM7.46667 11.0311V11.0383C9.81 11.1363 12.06 12.0728 13.8667 13.7025V3.71009C12.06 5.3398 9.81 6.27625 7.46667 6.37425V11.0311Z"
        fill="#B82831"
      />
    </svg>
  );
};

export default Speaker;
